import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import {IVendorOnboardProcessDocRejectTemplate, IVendorOnboardProcessDocApproveTemplate, IVendorOnboardProcessEmailLinkResend, IVendorOnboardProcessApproveEmailAdd} from '../models/vendor-onboard-process-search.model';

@Injectable({
  providedIn: 'root'
})
export class VendorOnboardProcessSearchService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  public getAllVendorOnboardProcessList(vendorOnboardProcessSearchParam: IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`VendorOnboardProcess/SearchVendorOnboardProcess`, vendorOnboardProcessSearchParam)
  }

  public getVendorOnboardProcessHistoryById(tempVendorId: number):Observable<any>{
    return this.apiService.getInd(`VendorOnboardProcess/StatusHistoryById/${tempVendorId}`)
  }

  public rejectDocTemplate(value: IVendorOnboardProcessDocRejectTemplate): Observable<any> {
    return this.apiService.post(`VendorOnboardProcess/RejectDocTemplate`, value);
}

public approveDocTemplate(value:IVendorOnboardProcessDocApproveTemplate):Observable<any>{
  return this.apiService.post(`VendorOnboardProcess/ApproveDocTemplate`,value)
}

public resendEmailLink(value:IVendorOnboardProcessEmailLinkResend):Observable<any>{
  return this.apiService.post(`VendorOnboardProcess/ReSendEmailLink`,value)
}

  public ExportVendorOnboardProcessSearch(vendorOnboardProcessSearchParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}VendorOnboardProcess/ExportVendorOnboardProcess`, vendorOnboardProcessSearchParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }

  public resendEmailLinkNCA(value:IVendorOnboardProcessEmailLinkResend):Observable<any>{
    return this.apiService.post(`VendorOnboardProcess/ReSendApplicantEmailLink`,value)
  }
}
